import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { Link } from 'wouter';
import { getJustificationRequestsCompanyList } from '../services/api_justification_requests';


function PreviewGiustificativi() {
  const { loading, token } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [richiesteHandled, setRichiesteHandled] = useState([]);
  const [richiestePending, setRichiestePending] = useState([]);
  
  useEffect(() => {
    const fetchJustificationRequests = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const justificationData = await getJustificationRequestsCompanyList(token);
        const pendingRequests = justificationData.filter((request) => request.status === null);
        const handledRequests = justificationData.filter((request) => request.status !== null);
        
        setRichiestePending(pendingRequests);
        setRichiesteHandled(handledRequests);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchJustificationRequests();
  }, [token]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateTimeString) => {
    const options = {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    };
    const dateTime = new Date(dateTimeString);
    const formattedDateTime = dateTime.toLocaleString('it-IT', options);
    const datePart = formattedDateTime.split(',')[0];
    const timePart = formattedDateTime.split(',')[1].trim();

    return `ore ${timePart} del ${datePart}`;
  };

  return (
    <div className="container mx-auto">
     <div className="my-8">
        <h2 className="text-md mb-2 ml-5">Ultime richieste da gestire:</h2>
        {isLoading ? (
          <div className="text-center bg-white p-4 m-5 rounded text-gray-500">Caricamento...</div>
        ) : error ? (
          <div className="text-center bg-white p-4 m-5 rounded text-red-500">Si è verificato un errore: {error.message}</div>
        ) : richiestePending.length > 0 ? (
          richiestePending.slice(0, 3).map((request, index) => (
          <div key={index} className="bg-white p-4 m-5 rounded text-gray-500">
            {request.justification && (
              <>
                <span className='uppercase'>{request.justification.description}</span> Dalle {request.datetime_from && formatDateTime(request.datetime_from)} alle {request.datetime_to && formatDateTime(request.datetime_to)}, <span className='pe-1'>dipendente</span> {(request.employee?.last_name || request.employee?.first_name) ? 
                  `${request.employee?.last_name?.toLocaleUpperCase() ?? ''} ${request.employee?.first_name?.toLocaleUpperCase() ?? ''}` : 
                  `${request.employee?.cf ?? ''}`} 
                 
              </>
            )}
          </div>
          ))
        ) : (
          <div className="text-center bg-white p-4 m-5 rounded text-gray-500">Non sono presenti richieste da gestire</div>
        )}
      </div>

      <div className="sm:my-8 flex justify-center mt-0 mr-5">
          <Link to="/pending_justifications">
            <button className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded sm:my-4 m-0">
              Visualizza tutte
            </button>
          </Link>
        </div>

      <div className="my-8">
        <h2 className="text-md mb-2 ml-5">Ultime richieste elaborate:</h2>
        {isLoading ? (
          <div className="text-center bg-white p-4 m-5 rounded text-gray-500">Caricamento...</div>
        ) : error ? (
          <div className="text-center bg-white p-4 m-5 rounded text-red-500">Si è verificato un errore: {error.message}</div>
        ) : richiesteHandled.length > 0 ? (
          richiesteHandled.slice(0, 3).map((request, index) => (
          <div key={index} className="bg-white p-4 m-5 rounded text-gray-500">
            {request.justification && (
              <>
                <span className='uppercase'>{request.justification.description}</span> Dalle {request.datetime_from && formatDateTime(request.datetime_from)} alle {request.datetime_to && formatDateTime(request.datetime_to)}, <span className='pe-1'>dipendente</span> {(request.employee?.last_name || request.employee?.first_name) ? 
                  `${request.employee?.last_name?.toLocaleUpperCase() ?? ''} ${request.employee?.first_name?.toLocaleUpperCase() ?? ''}` : 
                  `${request.employee?.cf ?? ''}`}, <span className='pe-1'>stato</span>  
                <span className='uppercase'>{request.status === 'approved' ? 'approvata' : request.status === 'rejected' ? 'rifiutata' : request.status}</span> 
              </>
            )}
          </div>
          ))
        ) : (
          <div className="text-center bg-white p-4 m-5 rounded text-gray-500">Non sono presenti richieste elaborate</div>
        )}
        <div className="sm:my-8 flex justify-center mt-0 mr-5">
          <Link to="/handled_justifications">
            <button className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded sm:my-4 m-0">
              Visualizza tutte
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PreviewGiustificativi;
